import { Fragment, useState } from 'react';

import Heading from './heading';
import PlantCard from './plant-card';
import ArrowRightBigIcon from 'components/icons/ArrowRightBigIcon';

import {
    useFungiblePlantedList,
    useFungibleClaimList
} from 'lib/hooks/use-fungible-planted';
import { PlantCardType} from 'types';

import { StyledPlantsWrapper, StyledPositionIcon } from './cards.style';


const PlantCards = () => {
  const [reset, setReset] = useState(false);
  const fungiblePlantedList = useFungiblePlantedList();
  const fungibleClaimList = useFungibleClaimList();
  // const fungiblePlantedRewardList =useFungiblePlantedRewardList()
    // const accountId = useAppSelector(selectAccountId);


  return (
    <Fragment>
      <Heading
        title="Plant Your Tokens"
        subtitle="By Planting OPN You Can Begin To Yield OCC’s"
      />
      <StyledPlantsWrapper>
        {fungiblePlantedList.length > 0 &&
          fungiblePlantedList.map((item) => (
            <PlantCard
              key={item.name}
              stateReset={[reset, setReset]}
              item={item as PlantCardType}
            />
          ))}
      </StyledPlantsWrapper>
        <Heading
        color="#ffcf23"
        title="Claim Your OCC Rewards"
        subtitle="Claim Your OCCs And Then Deposit Them In Your Wallet"
      />
      <StyledPlantsWrapper>
        <StyledPositionIcon>
          <ArrowRightBigIcon />
        </StyledPositionIcon>
        {fungibleClaimList.length > 0 &&
          fungibleClaimList.map((item) => (
            <PlantCard
              key={item.name}
              stateReset={[reset, setReset]}
              item={item as PlantCardType}
            />
          ))}
      </StyledPlantsWrapper>
    </Fragment>
  );
};

export default PlantCards;
